import { createSlice } from '@reduxjs/toolkit'

export const eventPageSlice = createSlice({
    name: 'eventPage',
    initialState: {
        exposure: null,
        exposureFancy: null,
        orders: null,
    },
    reducers: {
        getExposureSuccess: (state, action) => ({ ...state, exposure: action.payload }),
        getExposureFancySuccess: (state, action) => ({ ...state, exposureFancy: action.payload }),
        getExposureError: (state) => ({ ...state, exposure: null }),
        getOrdersSuccess: (state, action) => ({ ...state, orders: action.payload }),
        getOrdersError: (state) => ({ ...state, orders: null }),
    },
})

export const {
    getExposureError,
    getExposureSuccess,
    getExposureFancySuccess,
    getOrdersError,
    getOrdersSuccess,
} = eventPageSlice.actions

export default eventPageSlice.reducer
